// SAL: the Customer Settings lists (Salutations, Types, Industry, Job Titles, Postal Areas, Regions,
// Sales Executives) saved a blank row, and a row with Active unset got a 500 from the server.
// Their save() asks this first: the name must be filled and Active must be yes or no.
export function settingFormReady(vm, row, nameKey, nameLabel, activeKey = 'active') {
  const missing = []
  const name = row && row[nameKey]
  if (!(typeof name === 'string' ? name.trim() : name)) missing.push(`${nameLabel} is required.`)
  if (!(row && typeof row[activeKey] === 'boolean')) missing.push('Active is required (yes or no).')
  if (missing.length) {
    vm.$toast.add({ severity: 'warn', summary: 'Not saved', detail: missing.join(' '), life: 5000 })
    return false
  }
  return true
}

// a lookup sent as its id (Regions' Sales Exec and Branch, Postal Areas' Region)
export const idOf = v => (v && typeof v === 'object' ? v.id : v)
